"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerFormComponent = exports.FormContext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
require("core-js/features/array/find");
const FormContext = exports.FormContext = /*#__PURE__*/_react.default.createContext();

/**
 * HOC that must wrap the component which you want to use with FormGroup component.
 * Note that you must call the onFormValueChanged() in your specific component whenever
 * there is a value change. You may also call reigsterDOMNodes() in componentDidMount() if
 * you want to specifiy DOMNodes for which you want to apply the shaking animation.
 * See InputText component for examples.
 *
 * @param {class} Component is the class for which you want to be able to use the FormGroup component
 * @param {array} ValuePropName is an array of names of props containing the "value" of the component
 * (typically only one)
 *
 * @returns {class} New component that is now compatible with FormGroup component.
 */
const registerFormComponent = function (Component) {
  let ValuePropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["value"];
  class FormComponent extends _react.default.Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      //onFormValueChanged function that can be called in change handlers of wrapped Component
      //calls onChange function in FormGroup component
      (0, _defineProperty2.default)(this, "onFormValueChanged", function (value) {
        let shouldApplyError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let ID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.ID;
        _this.props.context.functions.onChange(value, shouldApplyError, ID);
      });
      //registerDOMNodes function that can be called in componentDidMount() of wrapped Component
      (0, _defineProperty2.default)(this, "registerDOMNodes", function (nodes) {
        let ID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.ID;
        _this.props.context.functions.registerDOMNodes(nodes, ID);
      });
      // unregisterDOMNodes function that can be called in componentWillUnmount of wrapped component
      (0, _defineProperty2.default)(this, "unregisterDOMNodes", function () {
        let ID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.ID;
        _this.props.context.functions.unregisterDOMNodes(ID);
      });
      if (this.props.context) {
        this.ID = this.props.context.functions.registerFormElement(this, ValuePropNames.some(name => name in this.props) ? this.props[ValuePropNames.find(name => name in this.props)] : "");
      }
      this.ref = /*#__PURE__*/_react.default.createRef();
    }
    componentDidUpdate(prevProps) {
      const {
        context,
        forwardedRef
      } = this.props;
      if (context) {
        if (forwardedRef?.current && prevProps.forwardedRef !== forwardedRef.current) {
          this.registerDOMNodes([forwardedRef.current]);
        }
      }
    }
    componentWillUnmount() {
      const {
        context
      } = this.props;
      if (context) context.functions.unregisterFormElement(this.ID);
    }
    render() {
      const {
        forwardedRef,
        context,
        ...rest
      } = this.props;
      if (context) {
        const item = context.data[this.ID];
        const isError = item ? item.isError : undefined;
        const validationMet = item ? item.validationMet : false;
        return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
          onFormValueChanged: this.onFormValueChanged,
          registerDOMNodes: this.registerDOMNodes,
          unregisterDOMNodes: this.unregisterDOMNodes,
          isError: isError,
          validationMet: validationMet,
          ref: forwardedRef || this.ref
        }, rest));
      } else {
        return /*#__PURE__*/_react.default.createElement(Component, this.props);
      }
    }
  }

  //If there are any ref values on element, then pass those along as well
  //Applies FormGroup context to wrapped component
  return /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(FormContext.Consumer, null, context => {
    return /*#__PURE__*/_react.default.createElement(FormComponent, (0, _extends2.default)({}, props, {
      forwardedRef: ref,
      context: context
    }));
  }));
};
exports.registerFormComponent = registerFormComponent;